import tocbot from 'tocbot'

(function ($, Drupal, once) {

    Drupal.behaviors.tocOpc = {
        attach: (context, settings) => {
            once('tocOpc', '[data-toc-opc-container-id]', context).forEach(
                (element) => {
                    // Add unique IDs to all headings that don't already have one
                    const contentElement = document.querySelector(element.dataset.tocOpcSelector);
                    if (contentElement) {
                        const headings = contentElement.querySelectorAll('h2, h3, h4, h5, h6');
                        headings.forEach((heading, index) => {
                            if (!heading.id) {
                                const headingText = heading.textContent.trim().toLowerCase()
                                    .replace(/[^\w\s-]/g, '')    // Remove special characters
                                    .replace(/\s+/g, '-');       // Replace spaces with hyphens

                                // Create unique ID using heading text and index
                                // heading.id = `heading-${headingText}-${random()}`;
                                heading.id = `${Math.random().toString(36).substring(2, 8)}`;
                            }
                        });
                    }
                    tocbot.init({
                        tocSelector: `#toc-container-${element.dataset.tocOpcContainerId}`,
                        contentSelector: `${element.dataset.tocOpcSelector}`,
                        headingSelector: 'h2,h3,h4,h5,h6',
                    });
                }
            );
        }
    };


})(jQuery, Drupal, once);
